import { Component, Input, inject } from '@angular/core';
import { ringSizes } from '../../page-config';
import { CartItem } from '../../model/cartItem';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { FormsModule } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ring-size-selector',
    templateUrl: './ring-size-selector.component.html',
    styleUrls: ['./ring-size-selector.component.scss'],
    imports: [FormsModule, NgbPopover]
})
export class RingSizeSelectorComponent {
  shoppingCartService = inject(ShoppingCartService);


  @Input() ring: CartItem;
  ringSizes: Array<string> = ringSizes.ireland;
  ringSize = 'M';

  updateShoppingCart(cartItem: CartItem): void {
    this.shoppingCartService.updateCartItem(cartItem);
  }
}
